(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tfc-swatch-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input',function(event){
    if(!event.target.matches('[data-swatch-request]'))return;
    var form=event.target.closest('.tfc-swatch-form');
    if(!form)return;
    var inputs=Array.from(form.querySelectorAll('[data-swatch-request]'));
    var required=inputs[0];
    required.setCustomValidity(required.value.trim()?'':required.dataset.requiredMessage);
    var count=form.querySelector('[data-swatch-count]');
    count.textContent=count.dataset.countTemplate.replace('__COUNT__',inputs.filter(function(input){return input.value.trim()}).length);
  });
  document.addEventListener('submit',function(event){
    var form=event.target;
    if(!form.matches('.tfc-swatch-form'))return;
    var inputs=Array.from(form.querySelectorAll('[data-swatch-request]'));
    inputs.forEach(function(input){input.value=input.value.trim()});
    inputs[0].setCustomValidity(inputs[0].value?'':inputs[0].dataset.requiredMessage);
    if(!form.reportValidity()){event.preventDefault();event.stopImmediatePropagation()}
  },true);
  } catch(e) { console.error(e); }
})();

})();
